import { render } from "./PrevisionaleDispacciamento.vue?vue&type=template&id=00249ff4&scoped=true"
import script from "./PrevisionaleDispacciamento.vue?vue&type=script&lang=js"
export * from "./PrevisionaleDispacciamento.vue?vue&type=script&lang=js"

import "./PrevisionaleDispacciamento.vue?vue&type=style&index=0&id=00249ff4&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00249ff4"]])

export default __exports__